/**
 * Utility functions for coordinate transformations
 */

// Earth's radius in meters
const EARTH_RADIUS = 6378137;

/**
 * Converts a point from EPSG:3857 (Web Mercator) to latitude/longitude
 * 
 * @param {number} x - The x coordinate in EPSG:3857 (meters)
 * @param {number} y - The y coordinate in EPSG:3857 (meters)
 * @returns {Object} An object with lat and lng properties
 */
export function fromEpsg3857ToLatLng(x, y) {
  // Convert from Web Mercator (EPSG:3857) to WGS84 (EPSG:4326)
  const lng = (x / EARTH_RADIUS) * (180 / Math.PI);
  const lat = (Math.atan(Math.exp(y / EARTH_RADIUS)) * 2 - Math.PI / 2) * (180 / Math.PI);
  
  return { lat, lng };
}

/**
 * Converts a point from latitude/longitude to EPSG:3857 (Web Mercator)
 * 
 * @param {number} lat - The latitude
 * @param {number} lng - The longitude
 * @returns {Array} An array with [x, y] coordinates in EPSG:3857
 */
export function fromLatLngToEpsg3857(lat, lng) {
  // Convert from WGS84 (EPSG:4326) to Web Mercator (EPSG:3857)
  const x = lng * (Math.PI / 180) * EARTH_RADIUS;
  const y = Math.log(Math.tan((Math.PI / 4) + (lat * (Math.PI / 180) / 2))) * EARTH_RADIUS;
  
  return [x, y];
}
